import React, { forwardRef } from 'react';

type Props = {
    readonly bundle: {
        readonly salesTag?: string;
    };
};

const BundleBadge = forwardRef<HTMLDivElement, Props>((props, ref) => {
    return (
        <div ref={ref} className="badges bundle-badge">
            <div className="bd marked bgreen">{props.bundle.salesTag}</div>
        </div>
    );
});

export default BundleBadge;
